// Natural roles per character id (C=Capitano, R=Braccio destro, F=Combattente, N=Navigatore,
// S=Supporto, X=Specialista, J=Jolly). Natural roles are highlighted and keep their full value.
const CODES = { C: "captain", R: "rightHand", F: "combat", N: "navigation", S: "support", X: "specialist", J: "jolly" };

const NATURAL = {
  // Cappello di Paglia
  luffy: "CF", zoro: "RF", nami: "NSX", usopp: "FSX", sanji: "RFS", chopper: "FSX", robin: "FSX", franky: "FSX", brook: "FS", jinbe: "RFNS",
  // Roger
  roger: "CF", rayleigh: "RFX", gaban: "RFN", crocus: "NSX", oden: "FSX", nozdon: "F", sunbell: "F", spencer: "F", donquino: "F",
  "millet-pine": "F", petermoo: "F", jacksonbanner: "F", erio: "F", rowing: "F", "max-marx": "F",
  // Rocks
  xebec: "CF", "whitebeard-rocks": "CRF", "bigmom-rocks": "CFS", "kaido-rocks": "CF", shiki: "CF", john: "CF", ochoku: "CF",
  "streusen-rocks": "SX", "gloriosa-rocks": "FS", ganzui: "F", "silver-axe": "F", stussy: "X",
  // Barbabianca
  newgate: "CF", marco: "RFSX", ace: "CF", jozu: "F", thatch: "FS", vista: "F", blamenco: "F", rakuyo: "F", namur: "F", blenheim: "F",
  curiel: "F", kingdew: "F", haruta: "F", atmos: "F", "speed-jiru": "F", fossa: "F", izo: "F", "oden-wb": "FSX",
  // Rosso
  shanks: "CF", beckman: "RFS", roux: "FS", yasopp: "FX", limejuice: "F", "bonk-punch": "F", monster: "F", "building-snake": "FN",
  hongo: "FSX", "howling-gab": "F", rockstar: "F",
  // Barbanera
  teach: "CFJ", burgess: "F", shiryu: "RF", augur: "FX", pizarro: "CF", lafitte: "NSX", devon: "FX", "sanjuan-wolf": "F", "vasco-shot": "F",
  docq: "SX", kuzan: "FX",
  // Cento Bestie
  kaido: "CF", king: "RF", queen: "FSX", jack: "F", whoswho: "FX", "black-maria": "FS", sasaki: "F", ulti: "F", pageone: "F",
  drake: "CFX", hawkins: "CFX", apoo: "CFS",
  // Big Mom
  linlin: "CF", katakuri: "RF", smoothie: "F", cracker: "F", perospero: "FS", compote: "F", daifuku: "F", oven: "F", montdor: "SX",
  brulee: "SX", pudding: "SX", streusen: "SX", pekoms: "FN", tamago: "FS",
  // Heart
  law: "CFSX", bepo: "NF", shachi: "F", penguin: "F", ikkaku: "FS",
  // Kid
  kid: "CFX", killer: "RFS", heat: "F", wire: "F", dive: "F", quincy: "F",
  // Donquixote
  doflamingo: "CFJ", trebol: "RFS", diamante: "F", pica: "F", vergo: "RFX", sugar: "SX", jora: "SX", "lao-g": "F", machvise: "F",
  "senor-pink": "FXJ", dellinger: "F", gladius: "FX", buffalo: "FS", baby5: "FJ", monet: "FS", caesar: "SX",
  // Cross Guild
  buggy: "CJ", crocodile: "CFSX", mihawk: "RF", daz: "F", galdino: "SX", alvida: "F", mohji: "S", cabaji: "F", richie: "F",
  // Sole
  tiger: "CF", "jinbe-sun": "RFNS", arlong: "CF", aladine: "RFSX", hatchan: "FS", macro: "F", gyaro: "F", tansui: "F",
  // Thriller Bark
  moria: "CFX", hogback: "SX", absalom: "FX", perona: "FSX", ryuma: "F", oars: "F",
  // Grande Flotta e Alleati
  cavendish: "CF", bartolomeo: "CFS", sai: "CF", ideo: "CF", leo: "CSX", orlumbus: "CNS", hancock: "CF", bonney: "CFJ",
  // Guerrieri Giganti
  dorry: "CF", brogy: "CF", oimo: "F", kashii: "F",
  hajrudin: "CF", stansen: "FSX", road: "NX", goldberg: "FS", gerd: "SX",
  // Marina
  garp: "CFS", sengoku: "CFSX", akainu: "CF", aokiji: "FX", kizaru: "F", fujitora: "FS", ryokugyu: "F", tsuru: "SX", smoker: "F",
  tashigi: "FS", koby: "FS", helmeppo: "F", hina: "F", momonga: "F", onigumo: "F", doberman: "F", dalmatian: "F",
  // Governo Mondiale
  imu: "CXJ", garling: "CF", shamrock: "CF", mars: "FX", warcury: "FS", nusjuro: "FX", "ju-peter": "FS", gunko: "FX", sommers: "FX",
  killingham: "FX",
  // Altri
  dragon: "CFSX", sabo: "RFS", kuma: "FSX", ivankov: "FS", bege: "CFSX", yamato: "FS", enel: "CFX", magellan: "CFX", riku: "CS",
  kyros: "CF", momonosuke: "CS", vivi: "CX", "caesar-others": "SX",
};

// Hand-tuned hidden values that differ from the raw table (e.g. Buggy's legendary leadership).
export const OVERRIDES = {
  buggy: { captain: 99, jolly: 99 },
  teach: { jolly: 90 },
  imu: { jolly: 88 },
  doflamingo: { jolly: 86 },
  bonney: { jolly: 78 },
  "senor-pink": { jolly: 66 },
  baby5: { jolly: 60 },
};

// Unlisted characters: their best non-leadership role (plus a near-equal second one).
const defaultNatural = (stats) => {
  const ranked = ["combat", "navigation", "support", "specialist"].sort((a, b) => stats[b] - stats[a]);
  return stats[ranked[0]] - stats[ranked[1]] <= 3 ? ranked.slice(0, 2) : ranked.slice(0, 1);
};

export const naturalRolesFor = (id, stats) =>
  NATURAL[id] ? [...NATURAL[id]].map((c) => CODES[c]) : defaultNatural(stats);
